/**
 * 사람이 막혔을 때 갈 곳.
 *
 * 화면 곳곳의 «고객센터로 문의해주세요» 가 **문의할 곳을 알려주지 않고 있었다.**
 * 특히 «이메일 찾기» 가 실패한 사람에게는 그것이 막다른 길이다 — 이메일을 잊어서
 * 온 사람에게 «연락해 보라» 고만 하는 셈이다.
 *
 * 한 곳에 둔다. 주소가 바뀔 때 화면을 뒤지지 않아도 되도록. 서버가 메일 템플릿에
 * 넣는 주소(us-api `settings.support_email`)와 같아야 한다.
 */
export const SUPPORT_EMAIL = "dev@frism.io";

/** 누르면 제목이 채워진 메일 쓰기 창이 열리는 주소. */
export const supportMailto = (subject: string) =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
